import { Box, Grid } from "@mui-wrapper";
import ARScene from "@assets/ar-scene.png";
import GoToScene from "@assets/go-to-scene.png";
import { HomeLink } from "@components/links/internal-links";

/** Content to show when page is not available */
export function PageNotFound(): React.JSX.Element {
  return (
    <Grid
      container
      sx={{
        backgroundImage: `url(${ARScene})`,
        height: "100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <HomeLink>
        <Box
          sx={{ height: "300px", cursor: "pointer" }}
          component="img"
          src={GoToScene}
          title="Go to HomePage"
          alt="Go to HomePage"
        />
      </HomeLink>
    </Grid>
  );
}
